import { getColor } from '@gif/shared-global';
import { ButtonVariants } from '..';

const primaryBlueColor = getColor('blue700');
const primaryWhiteColor = getColor('white');
const primaryBlackColor = getColor('neutral1400');
const disabledColor = '#ccc';
const disabledBorder = `2px solid ${disabledColor}`;
const tertiaryHoverBackgroundColor = '#e7e9eb';
const tertiaryActiveBackgroundColor = '#dbdddf';
const tertiaryHoverBlackBackgroundColor = tertiaryHoverBackgroundColor;
const tertiaryActiveBlackBackgroundColor = tertiaryActiveBackgroundColor;
const secondaryHoverBackgroundColor = tertiaryHoverBackgroundColor;
const secondaryActiveBackgroundColor = tertiaryActiveBackgroundColor;
const secondaryHoverBlackBackgroundColor = tertiaryHoverBackgroundColor;
const secondaryActiveBlackBackgroundColor = tertiaryActiveBackgroundColor;

interface GetVariantColors {
  backgroundColor: string;
  color: string;
  disabledColor: string;
  border: string;
  activeBorder: string;
  disabledBackgroundColor: string;
  disabledBorder: string;
  hoverBackgroundColor: string;
  hoverBorder: string;
  activeBackgroundColor: string;
}

export const getVariantColors = (
  variant: ButtonVariants = ButtonVariants.PRIMARY
): GetVariantColors => {
  const tertiary = {
    activeBorder: `2px solid ${primaryBlueColor}`,
    activeBackgroundColor: tertiaryActiveBackgroundColor,
    backgroundColor: 'transparent',
    border: 'none',
    color: primaryBlueColor,
    hoverBackgroundColor: tertiaryHoverBackgroundColor,
    hoverBorder: `2px solid ${primaryBlueColor}`,
    disabledBackgroundColor: 'transparent',
    disabledBorder: 'none',
    disabledColor: disabledColor,
  };

  const tertiaryBlack = {
    activeBorder: `2px solid ${primaryBlackColor}`,
    activeBackgroundColor: tertiaryActiveBlackBackgroundColor,
    backgroundColor: 'transparent',
    border: 'none',
    color: primaryBlackColor,
    hoverBackgroundColor: tertiaryHoverBlackBackgroundColor,
    hoverBorder: '2px solid #7f8a93',
    disabledBackgroundColor: 'transparent',
    disabledBorder: 'none',
    disabledColor: disabledColor,
  };

  const secondary = {
    activeBorder: `2px solid ${primaryBlueColor}`,
    activeBackgroundColor: secondaryActiveBackgroundColor,
    backgroundColor: 'transparent',
    border: `2px solid ${primaryBlueColor}`,
    color: primaryBlueColor,
    hoverBackgroundColor: secondaryHoverBackgroundColor,
    hoverBorder: '',
    disabledBackgroundColor: 'transparent',
    disabledBorder: disabledBorder,
    disabledColor: disabledColor,
  };

  const secondaryBlack = {
    activeBorder: `2px solid ${primaryBlackColor}`,
    activeBackgroundColor: secondaryActiveBlackBackgroundColor,
    backgroundColor: 'transparent',
    border: `2px solid ${primaryBlackColor}`,
    color: primaryBlackColor,
    hoverBackgroundColor: secondaryHoverBlackBackgroundColor,
    hoverBorder: '',
    disabledBackgroundColor: 'transparent',
    disabledBorder: disabledBorder,
    disabledColor: disabledColor,
  };

  const primary = {
    activeBorder: 'none',
    activeBackgroundColor: '#0042b4',
    backgroundColor: primaryBlueColor,
    border: 'none',
    color: primaryWhiteColor,
    hoverBackgroundColor: '#0145bf',
    hoverBorder: '',
    disabledBackgroundColor: disabledColor,
    disabledBorder: 'none',
    disabledColor: primaryWhiteColor,
  };

  const primaryBlack = {
    activeBorder: 'none',
    activeBackgroundColor: '#45474b',
    backgroundColor: primaryBlackColor,
    border: 'none',
    color: primaryWhiteColor,
    hoverBackgroundColor: '#2d2f31',
    hoverBorder: '',
    disabledBackgroundColor: disabledColor,
    disabledBorder: 'none',
    disabledColor: primaryWhiteColor,
  };

  switch (variant) {
    case ButtonVariants.TERTIARY:
      return tertiary;
    case ButtonVariants.TERTIARY_BLACK:
      return tertiaryBlack;
    case ButtonVariants.SECONDARY:
      return secondary;
    case ButtonVariants.SECONDARY_BLACK:
      return secondaryBlack;
    case ButtonVariants.PRIMARY_BLACK:
      return primaryBlack;
    default:
      return primary;
  }
};
